// "Keep talking" nudge card. Positioned by its parent (over the bottom half of the
// number tiles). Throbs via background colour (bg-throb) — stays opaque, never
// semi-transparent.
// `neutral` is reveal-arm B (PREREG_reveal_ab section 2): the copy must NOT imply anything is
// withheld or gated - no "to reveal / to continue" phrasing, or arm A's contingency comes back in
// through the wording. It is also quieter: no throb, since B is a gentle nudge, not a requirement.
export const KeepTalkingModal = ({ neutral = false }: { neutral?: boolean }) =>
  neutral ? (
    <div className="max-w-xs rounded-2xl bg-gray-700/90 px-5 py-4 text-center text-white shadow-lg">
      <p className="text-base font-semibold">Keep talking.</p>
    </div>
  ) : (
    <div className="bg-throb max-w-xs rounded-2xl bg-[#c182ac] px-6 py-6 text-center text-white shadow-2xl">
      <p className="text-lg font-semibold">Keep talking to reveal clues</p>
      <p className="mt-1 text-sm opacity-90">We want to hear your thinking!</p>
    </div>
  )
